import { jsx as _jsx } from "react/jsx-runtime";
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@mantine/core';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './AdvancedRevealButton.module.scss';
function AdvancedRevealButton(param) {
    var open = param.open, onClick = param.onClick;
    return /*#__PURE__*/ _jsx(Button, {
        variant: "link",
        classNames: {
            inner: styles.advancedButtonInner
        },
        leftSection: /*#__PURE__*/ _jsx(FontAwesomeIcon, {
            icon: open ? faChevronUp : faChevronDown
        }),
        onClick: onClick,
        children: open ? /*#__PURE__*/ _jsx(FormattedMessage, {
            id: "jL05H+",
            defaultMessage: "Hide Advanced Settings"
        }) : /*#__PURE__*/ _jsx(FormattedMessage, {
            id: "qgD3rD",
            defaultMessage: "Show Advanced Settings"
        })
    });
}
export default AdvancedRevealButton;
